import React from 'react';
import { Card, Input, Button, Typography, Checkbox } from '@material-tailwind/react';
import { Webinar } from '../../interfaces/webinar';

export const RegistrationForm: React.FC<{
  status: 'error' | 'success' | 'sending' | null;
  message: string | Error | null;
  onValidated: (formData: any) => void;
  videoId: string;
  closeDialog: () => void;
  isLiveEvent: boolean;
}> = ({ status, message, onValidated, videoId, closeDialog, isLiveEvent }) => {
  const [demoCheckbox, setDemoCheckbox] = React.useState<boolean>(false);
  const [formData, setFormData] = React.useState<{ [key: string]: string }>({
    EMAIL: '',
    FNAME: '',
    LNAME: '',
    MMERGE3: '',
    MMERGE5: isLiveEvent ? Webinar.REGISTER : Webinar.REQUEST,
    MMERGE4: videoId,
    MMERGE6: '',
  });

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    onValidated(formData);
  }

  return (
    <div className=" font-sans flex flex-col justify-between relative">
      {status === 'success' ? (
        <AfterSignup closeDialog={closeDialog} isLiveEvent={isLiveEvent} />
      ) : (
        <div className="flex justify-center !text-default px-4 ">
          <Card
            color="transparent"
            shadow={false}
            className="w-full "
            placeholder={undefined}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          >
            <form
              onSubmit={(e) => handleSubmit(e)}
              className="mt-2 mb-2 w-full max-w-[480px]  mx-auto text-default"
            >
              {status === 'error' && (
                <div
                  className="m-5 text-red-500"
                  dangerouslySetInnerHTML={
                    message !== null ? { __html: (message as string) ?? '' } : { __html: '' }
                  }
                />
              )}
              <div className="mb-4 flex flex-col gap-4 lg:gap-[18px]">
                <div>
                  <label htmlFor="email" className="text-sm">
                    Email address
                  </label>
                  <div>
                    <Input
                      autoComplete="off"
                      name="email"
                      type="email"
                      placeholder="Email address"
                      className="mt-1.5 !border !border-default/[12%] px-[14px] py-2.5 rounded-lg text-white placeholder:opacity-[32%] focus:!border-[#1570EF] text-base bg-[#0F1015]"
                      labelProps={{
                        className: 'hidden',
                      }}
                      containerProps={{ className: '!min-w-full' }}
                      onChange={(e) => setFormData({ ...formData, EMAIL: e.target.value })}
                      onPointerEnterCapture={undefined}
                      onPointerLeaveCapture={undefined}
                      crossOrigin={undefined}
                    />
                  </div>
                </div>

                {isLiveEvent && (
                  <>
                    <div className="grid grid-cols-2 gap-2">
                      <div>
                        <label htmlFor="firstName" className="text-sm">
                          First name
                        </label>
                        <div>
                          <Input
                            autoComplete="off"
                            name="firstName"
                            type="text"
                            placeholder="First name"
                            className="mt-1.5 !border !border-default/[12%] px-[14px] py-2.5 rounded-lg text-white placeholder:opacity-[32%] focus:!border-[#1570EF] text-base min-w-full"
                            labelProps={{
                              className: 'hidden',
                            }}
                            containerProps={{ className: '!min-w-full' }}
                            onChange={(e) => setFormData({ ...formData, FNAME: e.target.value })}
                            onPointerEnterCapture={undefined}
                            onPointerLeaveCapture={undefined}
                            crossOrigin={undefined}
                          />
                        </div>
                      </div>
                      <div>
                        <label htmlFor="lastName" className="text-sm">
                          Last name
                        </label>
                        <div>
                          <Input
                            autoComplete="off"
                            name="lastName"
                            type="text"
                            placeholder="Last name"
                            className="mt-1.5 !border !border-default/[12%] px-[14px] py-2.5 rounded-lg text-white placeholder:opacity-[32%] focus:!border-[#1570EF] text-base !w-full"
                            labelProps={{
                              className: 'hidden',
                            }}
                            containerProps={{ className: '!min-w-full' }}
                            onChange={(e) => setFormData({ ...formData, LNAME: e.target.value })}
                            onPointerEnterCapture={undefined}
                            onPointerLeaveCapture={undefined}
                            crossOrigin={undefined}
                          />
                        </div>
                      </div>
                    </div>

                    <div>
                      <label htmlFor="email" className="text-sm">
                        Company name
                      </label>
                      <div>
                        <Input
                          autoComplete="off"
                          name="business name"
                          type="business_name"
                          placeholder="Powerlabs"
                          className="mt-1.5 !border !border-default/[12%] px-[14px] py-2.5 rounded-lg text-white placeholder:opacity-[32%] focus:!border-[#1570EF] text-base bg-[#0F1015]"
                          labelProps={{
                            className: 'hidden',
                          }}
                          containerProps={{ className: '!min-w-full' }}
                          onChange={(e) => setFormData({ ...formData, MMERGE3: e.target.value })}
                          onPointerEnterCapture={undefined}
                          onPointerLeaveCapture={undefined}
                          crossOrigin={undefined}
                        />
                      </div>
                    </div>
                  </>
                )}

                <div className="flex items-center">
                  <Checkbox
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                    crossOrigin={undefined}
                    onChange={(e) => {
                      setDemoCheckbox(!demoCheckbox);
                      setFormData({ ...formData, MMERGE6: (!demoCheckbox).toString() });
                    }}
                  />
                  <div>
                    <Typography
                      placeholder={undefined}
                      onPointerEnterCapture={undefined}
                      onPointerLeaveCapture={undefined}
                      className="text-sm"
                    >
                      check this box to request for a demo
                    </Typography>
                  </div>
                </div>
              </div>
              <Button
                type="submit"
                className="mt-3 lg:text-base normal-case bg-primary text-secondary disabled:opacity-60"
                disabled={status === 'sending'}
                fullWidth
                placeholder={undefined}
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              >
                {isLiveEvent ? 'Register' : 'Request video'}
              </Button>
            </form>
          </Card>
        </div>
      )}
    </div>
  );
};

const AfterSignup: React.FC<{ closeDialog: () => void; isLiveEvent: boolean }> = ({
  closeDialog,
  isLiveEvent,
}) => {
  return (
    <div className="flex flex-col gap-6 justify-center items-center text-center mx-4 ">
      <img src="/images/waitlist-check.png" width={100} height={100} alt="check" />

      <div>
        <h2 className="font-semibold text-2xl mb-[9px] md:text-[32px] text-white">
          {isLiveEvent ? 'Registered succesfully' : 'Request sent'}
        </h2>
        <p className="opacity-60 md:text-xl text-white">
          An email has been sent to you with more details and information.
        </p>
      </div>

      <button
        type="button"
        className="btn text-white normal-case w-max mt-2 border-[0.5px] rounded p-2 border-[#D0D5DD] bg-[#0F1015]"
        onClick={closeDialog}
      >
        Back to home
      </button>
    </div>
  );
};
